'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _flickity = require('flickity');

var _flickity2 = _interopRequireDefault(_flickity);

var _functional = require('../utils/functional');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CarouselWatchCSSNoNav = function CarouselWatchCSSNoNav(el) {
  (0, _classCallCheck3.default)(this, CarouselWatchCSSNoNav);

  new _flickity2.default((0, _functional.getElement)('[data-module="carousel-watch-css-no-nav"]'), {
    cellAlign: 'center',
    watchCSS: 'true',
    wrapAround: true,
    pageDots: false,
    prevNextButtons: false
  });
};

exports.default = CarouselWatchCSSNoNav;